import { ConfigProvider } from "antd";
import locale from "antd/lib/locale/ko_KR";
import "moment/locale/ko";
import React from "react";
import ReactDOM from "react-dom/client";
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import useGlobalModalStore from "@store/modal";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// 토큰 에러 메시지 패턴
const TOKEN_ERROR_MESSAGES = ["Token is not active", "Refresh toked issued before the client session started", "Invalid refresh token. Token client and authorized client don't match"];

const isTokenError = (message?: string) => {
    if (!message) {
        return false;
    }
    return TOKEN_ERROR_MESSAGES.some(pattern => message.includes(pattern));
};

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
    mutationCache: new MutationCache({
        onError: (error: any, _variables, _context, mutation) => {
            // skipGlobalErrorHandler가 true면 전역 처리 스킵
            if (mutation.meta?.skipGlobalErrorHandler) {
                return;
            }

            const message = error?.data?.message;

            // 토큰 에러는 axios interceptor에서 이미 처리됨
            if (isTokenError(String(message))) {
                return;
            }

            // 전역 에러 모달 표시
            const errorMessage = typeof message === "object" ? message[0] : (message ?? "에러가 발생했습니다.");

            useGlobalModalStore.getState().setGlobalModal({
                modalType: "OneButtonModal",
                modalProps: {
                    title: errorMessage,
                    onConfirm: () => useGlobalModalStore.getState().hideGlobalModal(),
                    handleClose: () => useGlobalModalStore.getState().hideGlobalModal(),
                },
            });
        },
    }),
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <ConfigProvider locale={locale}>
                <App />
            </ConfigProvider>
        </BrowserRouter>
    </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
